import { useMemo } from "react";
import {
  PipelineStageType,
  CandidatesWithApplicationsQuery,
} from "../graphql/generated/graphql";

type FilteredCandidate = NonNullable<
  NonNullable<CandidatesWithApplicationsQuery["candidates"]>["nodes"]
>[0];

type PipelineStageAndRecruitmentModeCandidate = FilteredCandidate & {
  isHired: boolean;
  inRecruitmentMode: boolean;
};

export function usePipelineStageFilteredCandidates(
  filteredCandidates: FilteredCandidate[]
): PipelineStageAndRecruitmentModeCandidate[] {
  return useMemo(() => {
    if (!filteredCandidates.length) return [];

    return filteredCandidates.map((candidate) => {
      const jobs = candidate.jobsApplications.nodes;
      const isHired = jobs.some(
        (application) =>
          application.pipelineStage?.type === PipelineStageType.Hire
      );

      const inRecruitmentMode = jobs.some((application) =>
        application.pipelineStage?.translations?.nodes.some(
          (translation) => translation.title.toLowerCase() === "recruitment"
        )
      );

      return {
        ...candidate,
        isHired,
        inRecruitmentMode,
      };
    });
  }, [filteredCandidates]);
}
